import styled from 'styled-components';
import React from 'react';
import PropTypes from 'prop-types';

import Text from 'components/Text';
import { appConfig } from '../../../../configureApp';

const Area = styled.textarea`
  width: 100%;
  padding: 5px;
  border: 1px solid #ccc;
  min-height: 100px;
  font-size: ${appConfig.reactAppEnv === 'scti' ? '16px' : '0.86em'};
  font-family: inherit;
  border-radius: ${appConfig.reactAppEnv === 'scti' ? '8px' : '0'};
    &:disabled{
    background-color: ${(props) => props.dbc ? '' : appConfig.reactAppEnv === 'scti' ? '#F0F0F0' :'lightgray'};
    borderColor: ${appConfig.reactAppEnv === 'scti' ? '#C0C0C0' :'#ccc'};
  }
`;


export default function TextArea(props) {
  if (props.isSummary) {
    return <Text>{props.value || 'N/A'}</Text>;
  }
  return <Area {...props} />;
}

TextArea.propTypes = {
  isSummary: PropTypes.bool,
  value: PropTypes.any,
};




// WEBPACK FOOTER //
// ./app/containers/FastCover/components/TextArea/index.js